import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatchesService } from '../../services/matches.service';
import { SidenavService } from '../../services/sidenav.service';
import { SnackbarService } from '../../services/snackbar.service';
import { MatchesListComponent } from '../shared/matches-list/matches-list.component';

@Component({
  selector: 'app-matches',
  templateUrl: './matches.component.html',
  styleUrls: ['./matches.component.scss'],
  standalone: false,
})
export class MatchesComponent implements OnInit {
  @ViewChild(MatchesListComponent, { static: true })
  matchesListComponent: MatchesListComponent;
  @BlockUI() blockUI: NgBlockUI;

  sidenav: MatSidenav;
  matches: any[];
  rounds: any[];
  roundMatches: any[];
  roundSelected: string = 'GROUP_STAGE';
  syncing = false;

  constructor(
    private sidenavService: SidenavService,
    private matchesService: MatchesService,
    private snackbar: SnackbarService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  ngOnInit() {}

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/admin']);
  }

  save() {
    if (this.matchesListComponent.hasInvalidScoresForSubmit()) {
      this.snackbar.warning(
        'Los resultados deben ser números enteros iguales o mayores que 0.',
      );
      return;
    }

    this.blockUI.start();

    this.matchesService
      .updateResults(this.matchesListComponent.getResults())
      .then(() => {
        this.blockUI.stop();
        this.snackbar.success(
          'Los resultados se han actualizado correctamente.',
        );
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackbar.error(error.message);
      });
  }

  syncMatches() {
    if (this.syncing) {
      return;
    }

    this.syncing = true;
    this.blockUI.start();

    this.matchesService
      .sync()
      .then(async (result: any) => {
        await this.matchesListComponent.ngOnInit();
        this.snackbar.success(
          `Sincronizacion completada: ${result.created} nuevos, ${result.updated} actualizados.`,
        );
      })
      .catch((error) => {
        this.snackbar.error(error.message);
      })
      .finally(() => {
        this.syncing = false;
        this.blockUI.stop();
      });
  }
}
